import React, {Component} from 'react';
import {Link, Redirect} from 'react-router-dom';
import AnchorLink from 'react-anchor-link-smooth-scroll'

import './SubscribeModule.scss';

import GetIcon from '../GetIcon/GetIcon';

class SubscribeModule extends Component {

  componentDidMount() {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.innerHTML = `
      /** This section is only needed once per page if manually copying **/
      if (typeof MauticSDKLoaded == 'undefined') {
          var MauticSDKLoaded = true;
          var head            = document.getElementsByTagName('head')[0];
          var script          = document.createElement('script');
          script.type         = 'text/javascript';
          script.src          = 'https://mautic.unigine.com/media/js/mautic-form.js';
          script.onload       = function() {
              MauticSDK.onLoad();
          };
          head.appendChild(script);
          var MauticDomain = 'https://mautic.unigine.com';
          var MauticLang   = {
              'submittingMessage': "Please wait..."
          }
      } else if (typeof MauticSDK != 'undefined') {
          MauticSDK.onLoad();
      }
    `;
    this.instance.appendChild(s);
  }

  openPopup = (e) => {
    document.querySelector('#subscribe-modal').classList.add('show');
  }

  closePopup = (e) => {
    document.querySelector('#subscribe-modal').classList.remove('show');
  }

  modalClickHandler = (e) => {
    if (e.target.classList.contains('show')) {
      this.closePopup();
    }
  }

  createMarkup = () => {
    return {__html: 
      `<script type="text/javascript">
        setTimeout(() => {
          /** This section is only needed once per page if manually copying **/
          if (typeof MauticSDKLoaded == 'undefined') {
              var MauticSDKLoaded = true;
              var head            = document.getElementsByTagName('head')[0];
              var script          = document.createElement('script');
              script.type         = 'text/javascript';
              script.src          = 'https://mautic.unigine.com/media/js/mautic-form.js';
              script.onload       = function() {
                  MauticSDK.onLoad();
              };
              head.appendChild(script);
              var MauticDomain = 'https://mautic.unigine.com';
              var MauticLang   = {
                  'submittingMessage': "Please wait..."
              }
          } else if (typeof MauticSDK != 'undefined') {
              MauticSDK.onLoad();
          }
        }, 2000);
      </script>`
    };
  }

  render () {
    return (
      <div className="social-subscribe">

        <button id="subscribe-modal-show-btn" onClick={this.openPopup} className="btn btn-green-white button--sign-in">Sign Up for UNIGINE News</button>

        <div id="subscribe-modal" className="modal" onClick={this.modalClickHandler}>
          <div className="modal-content animate-top">
            <span id="subscribe-modal-close-btn" className="close" title="Close" onClick={this.closePopup}>
              <GetIcon name="close"/>
            </span>

            <div className="modal-header">
              <span>Sign Up for UNIGINE News</span>
            </div>
            
            <div className="modal-body">
              <div className="modal-body">
                <div id="mauticform_wrapper_podpiskananovosti" className="mauticform_wrapper">
                  <form className="subscribe-form" autoComplete="false" role="form" method="post" action="https://mautic.unigine.com/form/submit?formId=3" id="mauticform_footernewssubscription" data-mautic-form="footernewssubscription" encType="multipart/form-data" target="mauticiframe_footernewssubscription">
                    <div className="mauticform-error form-final-message form-final-message--error" id="mauticform_footernewssubscription_error"></div>
                    <div className="mauticform-message form-final-message form-final-message--success" id="mauticform_footernewssubscription_message"></div>
                    <div className="mauticform-innerform">
                      <div className="mauticform-page-wrapper mauticform-page-1" data-mautic-form-page="1">
                        <div id="mauticform_footernewssubscription_email" data-validate="email" data-validation-type="email" className="mauticform-row mauticform-email mauticform-field-1 mauticform-required form-error-message-wrapper">
                          <input id="mauticform_input_footernewssubscription_email" name="mauticform[email]" className=" form-email mauticform-input" type="email" placeholder="Email"/>
                          <span className="mauticform-errormsg form-error-message" style={{display: 'none'}}>Please enter your mail</span>
                        </div>
                        
                        <div id="mauticform_footernewssubscription_what_type_of_emails_do_yo" data-validate="what_type_of_emails_do_yo" data-validation-type="radiogrp" className="mauticform-row mauticform-radiogrp mauticform-field-8 mauticform-required mautic-form-group form-checkbox form-error-message-wrapper">
                          <p className="form-text">What type of emails do you want to receive?</p>

                          <div className="mauticform-radiogrp-row">
                            <label className="radio-label" htmlFor="mauticform_radiogrp_radio_what_type_of_emails_do_yo_entertainment0">
                              <input type="radio" name="mauticform[what_type_of_emails_do_yo]" defaultChecked value="Entertainment" className="visually-hidden mauticform-radiogrp-radio" id="mauticform_radiogrp_radio_what_type_of_emails_do_yo_entertainment0"/>
                              <span className="radio-indicator"></span>
                              <span className="radio-text">Entertainment (Game, Film, ART)</span>
                            </label>
                          </div>

                          <div className="mauticform-radiogrp-row">
                            <label className="radio-label" htmlFor="mauticform_radiogrp_radio_what_type_of_emails_do_yo_enterprise1">
                              <input type="radio" name="mauticform[what_type_of_emails_do_yo]" value="Enterprise" className="visually-hidden mauticform-radiogrp-radio" id="mauticform_radiogrp_radio_what_type_of_emails_do_yo_enterprise1"/>
                              <span className="radio-indicator"></span>
                              <span className="radio-text">Enterprise (Simulations ...)</span>
                            </label>
                          </div>

                          <span className="mauticform-errormsg form-error-message" style={{display: 'none'}}>This is required.</span>
                        </div>

                        <div id="mauticform_footernewssubscription_preferredlanguage" data-validate="preferredlanguage" data-validation-type="radiogrp" className="mauticform-row mauticform-radiogrp mauticform-field-4 mauticform-required  form-checkbox form-error-message-wrapper mautic-form-group">

                          <p className="form-text">I want to receive updates in</p>

                          <div className="mauticform-radiogrp-row">
                            <label className="radio-label" htmlFor="mauticform_radiogrp_radio_preferredlanguage_en0">
                              <input type="radio" name="mauticform[preferredlanguage]" defaultChecked value="en" className="visually-hidden mauticform-radiogrp-radio" id="mauticform_radiogrp_radio_preferredlanguage_en0"/>
                              <span className="radio-indicator"></span>
                              <span className="radio-text">English</span>
                            </label>
                          </div>

                          <div className="mauticform-radiogrp-row">
                            <label className="radio-label" htmlFor="mauticform_radiogrp_radio_preferredlanguage_ru1">
                              <input type="radio" name="mauticform[preferredlanguage]" value="ru" className="visually-hidden mauticform-radiogrp-radio" id="mauticform_radiogrp_radio_preferredlanguage_ru1"/>
                              <span className="radio-indicator"></span>
                              <span className="radio-text">Русский</span>
                            </label>
                          </div>
                          <div className="mauticform-radiogrp-row">
                            <label className="radio-label" htmlFor="mauticform_radiogrp_radio_preferredlanguage_zh2">
                              <input type="radio" name="mauticform[preferredlanguage]" value="zh" className="visually-hidden mauticform-radiogrp-radio" id="mauticform_radiogrp_radio_preferredlanguage_zh2"/>
                              <span className="radio-indicator"></span>
                              <span className="radio-text">中文</span>
                            </label>
                          </div>
                          <span className="mauticform-errormsg form-error-message" style={{display: 'none'}}>This is required.</span>
                        </div>
                        
                        <div id="mauticform_footernewssubscription_dreamlanguage" className="mauticform-row mauticform-select mauticform-field-5">
                          <p className="form-text">optionally: if available, please send me the updates in</p>
                          <select id="mauticform_input_footernewssubscription_dreamlanguage" name="mauticform[dreamlanguage]" className="mauticform-selectbox">
                            <option value=""></option>
                            <option value="fr">French</option>
                            <option value="de">German</option>
                            <option value="es">Spanish</option>
                            <option value="pt">Portuguese</option>
                            <option value="ja">Japanese</option>
                            <option value="ko">Korean</option>
                          </select>
                          <span className="mauticform-errormsg" style={{display: 'none'}}></span>
                        </div>
                        <input id="mauticform_checkboxgrp_checkbox_privacypolicy_11" name="mauticform[privacypolicy]" value="1" className="mauticform-hidden" type="hidden"/>
                        <input id="mauticform_input_footernewssubscription_country" name="mauticform[country]" value="en" className="mauticform-hidden" type="hidden"/>
                        <input id="mauticform_input_footernewssubscription_sourceaction" name="mauticform[sourceaction]" value="hackathon:footer-subscribe-form" className="mauticform-hidden" type="hidden"/>

                        
                        <button type="submit" form="mauticform_footernewssubscription" name="mauticform[submit]" id="mauticform_input_submit" className="mauticform-button form-button btn btn-green-black">Subscribe</button>
                      </div>
                    </div>

                    <input type="hidden" name="mauticform[formId]" id="mauticform_footernewssubscription_id" value="3"/>
                    <input type="hidden" name="mauticform[return]" id="mauticform_footernewssubscription_return" value=""/>
                    <input type="hidden" name="mauticform[formName]" id="mauticform_footernewssubscription_name" value="footernewssubscription"/>

                    <input type="hidden" name="mauticform[messenger]" id="mauticform_footernewssubscription_messenger" value="1"/>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ref={el => (this.instance = el)} ></div>
      </div>
    );
  }
};

export default SubscribeModule;
